import { Component, OnInit } from '@angular/core';
import { NbSearchService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { DashService } from '../dash.service';
import { liveSearch } from '../dash.operator';

@Component({
  selector: 'app-search-ui',
  templateUrl: './search-ui.component.html',
  styleUrls: ['./search-ui.component.css']
})
export class SearchUiComponent implements OnInit {
  searchValue = '';
  custDatas = [];


  private userQuerySubject = new Subject<string>();

  searchUsers(query: string) {
    console.log("search Users: " + query)
    this.userQuerySubject.next(query);
  }

  readonly custDatas$ = this.userQuerySubject.pipe(
    liveSearch(query => this.dashService.fetchUsers(query))
  );

  removeNonAlphaNumeric(str) {
    return str.replace(/[^a-zA-Z0-9@._%+-]/g, "");
  }

  constructor(public dashService: DashService, private searchService: NbSearchService) {
    this.searchService.onSearchInput()
    .subscribe((data: any) => {
      this.searchValue = data.term;
      let newTerm = this.removeNonAlphaNumeric(data.term);
        console.log(this.searchValue,"new Term:",newTerm);
        this.searchUsers(newTerm)
    })

  }

  ngOnInit(): void {
  }

  clearSearchInput() {
    this.searchValue = "";
  }

}
